export default "__VITE_ASSET__BmmwVaKi__"